import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { css } from "@emotion/core"
import Colors, { tiles } from "./colors"
//

const Restaurant = ({ name, link }) => {

  const data = useStaticQuery(graphql`
    query MuralQuery {
      allImageSharp {
        edges {
          node {
            fixed(width:250, height:200) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  `)

  console.log(data, data.allImageSharp.edges)

  const randomImageNode = data.allImageSharp.edges[Math.floor(Math.random()*data.allImageSharp.edges.length)].node

  console.log(randomImageNode)

  const randomColor = tiles[Math.floor(Math.random()*tiles.length)]

  return (
    <a
      href={link}
      target="blank"
      rel="noopener noreferrer"
      css={css`
      flex: 0 1 250px;
      margin: 1rem;
      transition: .125s linear box-shadow;
      text-decoration: none;
      color: ${Colors.darkblue};
      height: 200px;
      width: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-size: cover;
      position: relative;
      &:hover {
        box-shadow: 0px 0px 4px rgba(0,0,0,0.8);
        transition: .25s linear box-shadow;
        color: inherit;
      }
    `}>
      <div css={css`
        height: 100%;
        width: 100%;
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-family: merriweather;
        font-size: 1.25rem;
        text-align: center;
        border: 2px solid ${Colors.darkblue};
        transition: .25s linear all;
        &:before {
          background-color: ${randomColor};
          content: "";
          width: 100%;
          height: 100%;
          opacity: 0;
          position: absolute;
          z-index: 0;
          transition: .25s linear all;
        }
        &:hover {
          &:before {
            opacity: 1;
          }
          border: none;
        }
      `}>
        <div style={{zIndex:2}}>{name}</div>
      </div>
    </a>
  )
}

export default Restaurant


/*
return (
    <a
      href={link}
      target="blank"
      rel="noopener noreferrer"
      css={css`
      flex: 0 1 250px;
      margin: 1rem;
      transition: .125s linear box-shadow;
      text-decoration: none;
      color: inherit;
      &:hover {
        box-shadow: 0px 0px 4px rgba(0,0,0,0.8);
        transition: .125s linear box-shadow;
        color: inherit;
      }
    `}>
      <BackgroundImage
        fixed={randomImageNode.fixed}
        css={css`
          height: 200px;
          width: 250px;
          display: flex !important;
          align-items: center;
          justify-content: center;
          background-size: cover;
        `}
      >
        <div css={css`
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:before {
            position: absolute;
            z-index: -100;
            content:"";
            background-color: rgba(255,255,255,0.75);
            height: 100%;
            width: 100%;
            transition: .25s linear all;
          }
          &:hover {
            &:before {
              height: 50%;
              background-color: rgba(255,255,255,0.9);
              
            }
          }
        `}>
          <div css={css`
            padding: 1rem;
            font-weight: bold;
            font-family: merriweather;
            font-size: 1.25rem;
          `}>
            {name}
          </div>
        </div>
      </BackgroundImage>
    </a>
  )
  */